module.exports = __webpack_public_path__ + "img/music-logo.debda9f0.png";